import i18n from '@/locales'
export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('scope.text_669'),
        action: (obj) => {
          this.createDialog('ViewHistoryExchangeRateDialog', {
            data: [obj],
            columns: this.columns,
            onManager: this.onManager,
          })
        },
        meta: (obj) => {
          return {
            validate: true,
          }
        },
      },
    ]
  },
}
